import {
  FormConfig,
  InputConfig,
  InputLoopConfig,
  InputRepeaterConfig,
  StaticConfig,
} from '../../state/configuration'
import { defineAll } from '../../util/defineAll'

/* GROUPS */

const staticTypes = defineAll<StaticConfig['type']>()('heading', 'divider')

export const isStaticConfig = (config: FormConfig[0]): config is StaticConfig =>
  (staticTypes as string[]).includes(config.type)

export const isInputConfig = (config: FormConfig[0]): config is InputConfig =>
  !isStaticConfig(config)

/* INPUTS */

export const isLoopConfig = (config: InputConfig): config is InputLoopConfig =>
  config.type === 'inputLoop'

export const isRepeaterConfig = (config: InputConfig): config is InputRepeaterConfig =>
  config.type === 'inputRepeater'
